import { useMemo } from 'react';
import { startCase } from 'lodash';
import FilterDropdown from 'components/elements/Dropdown/FilterDropdown';
import { useAvailableCities } from 'hooks/useUserCityAccess';
import { useUserCountySelection, useUserMultiRegionSelection } from 'state/dashboard';

const CountySelection = () => {
  const [selectedCounties, setSelectedCounties] = useUserCountySelection();
  const [selectedRegions] = useUserMultiRegionSelection();
  const { availableRegions } = useAvailableCities();

  const countyOptions = useMemo(() => {
    if (!selectedRegions || selectedRegions.length === 0) {
      return [];
    }

    const countyById = new Map<string, string>();
    selectedRegions.forEach((regionCode) => {
      const counties = availableRegions[regionCode]?.counties || {};
      Object.entries(counties).forEach(([countyId, countyData]) => {
        const nameFromApi = countyData.name?.trim();
        if (nameFromApi === 'unknown') {
          // If the API returns "unknown" for the county name, we skip it to avoid showing a confusing label in the dropdown.
          return;
        }
        const label =
          nameFromApi || startCase(String(countyId).replace(/-/g, ' ').toLowerCase());
        countyById.set(countyId, label);
      });
    });

    return Array.from(countyById.entries())
      .map(([countyId, label]) => ({
        value: countyId,
        label,
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [availableRegions, selectedRegions]);

  return (
    <FilterDropdown
      options={countyOptions}
      onSubmit={(values: string[]) => setSelectedCounties(values)}
      onClearAll={() => setSelectedCounties([])}
      checkedValues={selectedCounties}
      setCheckedValues={setSelectedCounties}
      maxHeight="280px"
      isFilterEnabled
      sortSelectedFirst
    >
      County
    </FilterDropdown>
  );
};

export default CountySelection;
